import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useMutation } from '..';

interface UsePayoutRequestProps {
  collaborationId: string;
  onSuccess: TypeAny;
}

export function usePayoutRequest({ collaborationId, onSuccess }: UsePayoutRequestProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { data, error, isLoading, mutate } = useMutation({
    mutationKey: 'influencer-payout-request',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/payout/${collaborationId}/request`,
        body: { collaboration_id: collaborationId },
        token
      }).then((response: ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    error,
    data,
    isLoading,
    mutate
  };
}
